
import axios, { AxiosError, AxiosInstance } from 'axios';
import * as RemoteApiPoint from './../../src/remote-api-point';
import {EventBus} from './../../src/eventbus';
import * as Store from './../../src-gen/store';
import * as Data from './../data';
import * as ServerData from './../server-data';
import MasterReaderService from './../service/spineapi/MasterReaderService';
import PaymentRequestReaderService from './../service/paymentapi/PaymentRequestReaderService';
import PaymentSchedulePlanWriterService from './../service/spineapi/PaymentSchedulePlanWriterService';
import SpaWriterService from './../service/paymentapi/SpaWriterService';

// tslint:disable



export class GetPaymentPlanDetails {

    
    public static execute1(ppCode: string|undefined, f: (output: Data.Payment.PaymentPlanDetails) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.SpineApi): void {
      GetPaymentPlanDetails.execute(new Data.Payment.GetPaymentPlanDetailsInput(ppCode), f, eh, axoisInstance);
    } 

    

    public static execute(input: Data.Payment.GetPaymentPlanDetailsInput, f: (output: Data.Payment.PaymentPlanDetails) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.SpineApi): void {

    

    

        MasterReaderService.getPaymentPlanDetails(axoisInstance, this.mapInput(input),
            ((output: ServerData.PPData$PaymentPlanDetails) => {
                      const mappedOutput = this.mapOutput(output);

           

           Store.Mutation.Payment.PaymentStore.UPDATE_PAYMENT_PLAN_DETAILS(mappedOutput);
             f(mappedOutput);
             
            }), eh);

    }

    

    private static mapInput(input: Data.Payment.GetPaymentPlanDetailsInput): ServerData.MasterWebReader.GetPaymentPlanDetails$Input {
        return new GetPaymentPlanDetails$MapperCode().mapInput(input);
    }

    private static mapOutput(output: ServerData.PPData$PaymentPlanDetails): Data.Payment.PaymentPlanDetails {
        return new GetPaymentPlanDetails$MapperCode().mapOutput(output);
    }

    private static handleError(error: AxiosError): void {
         console.log('got error' + error.response);
    }
}

abstract class GetPaymentPlanDetails$Mapper {

    public mapInput(input: Data.Payment.GetPaymentPlanDetailsInput): ServerData.MasterWebReader.GetPaymentPlanDetails$Input {
        return ServerData.MasterWebReader.GetPaymentPlanDetails$Input.fromJson(input.toJson());
    }

    public mapOutput(output: ServerData.PPData$PaymentPlanDetails): Data.Payment.PaymentPlanDetails {
        return Data.Payment.PaymentPlanDetails.fromJson(output.toJson());
    }

}

class GetPaymentPlanDetails$MapperCode extends GetPaymentPlanDetails$Mapper {

}

       


export class GetSpaPaymentRequests {

    
    public static execute1(clientFileId: string, f: (output: Data.Payment.PaymentRequestDetailsWithEntries[]) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.PaymentApi): void {
      GetSpaPaymentRequests.execute(new ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input(clientFileId), f, eh, axoisInstance);
    } 

    

    public static execute(input: ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input, f: (output: Data.Payment.PaymentRequestDetailsWithEntries[]) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.PaymentApi): void {

    

    

        PaymentRequestReaderService.getSpaPaymentRequests(axoisInstance, this.mapInput(input),
            ((output: ServerData.SpineData$PaymentRequestDetailsWithEntries[]) => {
                      const mappedOutput = this.mapOutput(output);

           

           
             f(mappedOutput);
             
            }), eh);

    }

    

    private static mapInput(input: ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input): ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input {
        return new GetSpaPaymentRequests$MapperCode().mapInput(input);
    }

    private static mapOutput(output: ServerData.SpineData$PaymentRequestDetailsWithEntries[]): Data.Payment.PaymentRequestDetailsWithEntries[] {
        return new GetSpaPaymentRequests$MapperCode().mapOutput(output);
    }

    private static handleError(error: AxiosError): void {
         console.log('got error' + error.response);
    }
}

abstract class GetSpaPaymentRequests$Mapper {

    public mapInput(input: ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input): ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input {
        return input; 
    }

    public mapOutput(output: ServerData.SpineData$PaymentRequestDetailsWithEntries[]): Data.Payment.PaymentRequestDetailsWithEntries[] {
        return  output.map((x) => Data.Payment.PaymentRequestDetailsWithEntries.fromJson(x.toJson()));
    }

}

class GetSpaPaymentRequests$MapperCode extends GetSpaPaymentRequests$Mapper {

}

       


export class RecalculatePSPlan {

    

    

    public static execute(input: Data.Payment.RecalculatePSPlanInput, f: (output: string) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.SpineApi): void {

    

    

        PaymentSchedulePlanWriterService.recalculatePSPlan(axoisInstance, this.mapInput(input),
            ((output: string) => {
                      const mappedOutput = this.mapOutput(output);

           

           
             f(mappedOutput);
             EventBus.$emit('Payment::RecalculatePSPlan', mappedOutput);
            }), eh);

    }

    
    public static interested(f: (output: string) => void): (output: string) => void {
        EventBus.$on('Payment::RecalculatePSPlan', f);
        return f;
    }

    public static notInterested(f: (output: string) => void): void {
        EventBus.$off('Payment::RecalculatePSPlan', f);
    }


    public static nobodyInterested(): void  {
        EventBus.$off('Payment::RecalculatePSPlan');
    }
    

    private static mapInput(input: Data.Payment.RecalculatePSPlanInput): ServerData.PaymentSchedulePlanWebWriter.RecalculatePSPlan$Input {
        return new RecalculatePSPlan$MapperCode().mapInput(input);
    }

    private static mapOutput(output: string): string {
        return new RecalculatePSPlan$MapperCode().mapOutput(output);
    }

    private static handleError(error: AxiosError): void {
         console.log('got error' + error.response);
    }
}

abstract class RecalculatePSPlan$Mapper {

    public mapInput(input: Data.Payment.RecalculatePSPlanInput): ServerData.PaymentSchedulePlanWebWriter.RecalculatePSPlan$Input {
        return ServerData.PaymentSchedulePlanWebWriter.RecalculatePSPlan$Input.fromJson(input.toJson());
    }

    public mapOutput(output: string): string {
        return output
    }

}

class RecalculatePSPlan$MapperCode extends RecalculatePSPlan$Mapper {

}

       


export class DraftPSPlan {

    

    

    public static execute(input: Data.Payment.DraftPSPlanInput, f: (output: string) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.SpineApi): void {

    

    

        PaymentSchedulePlanWriterService.draftPSPlan(axoisInstance, this.mapInput(input),
            ((output: string) => {
                      const mappedOutput = this.mapOutput(output);

           

           
             f(mappedOutput);
             EventBus.$emit('Payment::DraftPSPlan', mappedOutput);
            }), eh);

    }

    
    public static interested(f: (output: string) => void): (output: string) => void {
        EventBus.$on('Payment::DraftPSPlan', f);
        return f;
    }

    public static notInterested(f: (output: string) => void): void {
        EventBus.$off('Payment::DraftPSPlan', f);
    }


    public static nobodyInterested(): void  {
        EventBus.$off('Payment::DraftPSPlan');
    }
    

    private static mapInput(input: Data.Payment.DraftPSPlanInput): ServerData.PaymentSchedulePlanWebWriter.DraftPSPlan$Input {
        return new DraftPSPlan$MapperCode().mapInput(input);
    }

    private static mapOutput(output: string): string {
        return new DraftPSPlan$MapperCode().mapOutput(output);
    }

    private static handleError(error: AxiosError): void {
         console.log('got error' + error.response);
    }
}

abstract class DraftPSPlan$Mapper {

    public mapInput(input: Data.Payment.DraftPSPlanInput): ServerData.PaymentSchedulePlanWebWriter.DraftPSPlan$Input {
        return ServerData.PaymentSchedulePlanWebWriter.DraftPSPlan$Input.fromJson(input.toJson());
    }

    public mapOutput(output: string): string {
        return output
    }

}

class DraftPSPlan$MapperCode extends DraftPSPlan$Mapper {

}

       


export class CollectThroughPg {

    

    

    public static execute(input: Data.Payment.CollectThroughPgInput, f: (output: string) => void, eh: ((error: AxiosError) => void)|undefined = undefined, axoisInstance: AxiosInstance = RemoteApiPoint.PaymentApi): void {

    

    

        SpaWriterService.collectThroughPg(axoisInstance, this.mapInput(input),
            ((output: string) => {
                      const mappedOutput = this.mapOutput(output);

           

           
             f(mappedOutput);
             
            }), eh);

    }

    

    private static mapInput(input: Data.Payment.CollectThroughPgInput): ServerData.SpaWebWriter.CollectThroughPg$Input {
        return new CollectThroughPg$MapperCode().mapInput(input);
    }

    private static mapOutput(output: string): string {
        return new CollectThroughPg$MapperCode().mapOutput(output);
    }

    private static handleError(error: AxiosError): void {
         console.log('got error' + error.response);
    }
}

abstract class CollectThroughPg$Mapper {

    public mapInput(input: Data.Payment.CollectThroughPgInput): ServerData.SpaWebWriter.CollectThroughPg$Input {
        return ServerData.SpaWebWriter.CollectThroughPg$Input.fromJson(input.toJson());
    }

    public mapOutput(output: string): string {
        return output
    }

}

class CollectThroughPg$MapperCode extends CollectThroughPg$Mapper {

}

       

     